import { useBaseMutation } from "../baseMutation";
import { RestError } from "@maven-rest/common/HttpRequest";
import { VerifyUserVerificationCodeRequest, VerifyUserVerificationCodeResponse } from "@maven-rest/sso/UserVerificationCode.dto";
import { UserVerificationCodeUrl } from "@maven-rest/sso/UserVerificationCode.url";

export function useVerifyVerificationCodeMutation(req: {
  onSuccess: (data: VerifyUserVerificationCodeResponse, variables: VerifyUserVerificationCodeRequest, context: unknown) => void;
  onError: (error: RestError<VerifyUserVerificationCodeResponse>, variables: VerifyUserVerificationCodeRequest, context: unknown) => void;
}) {
  return useBaseMutation({
    fnOption: {
      host: process.env.REACT_APP_SSO_BE_URL,
      url: UserVerificationCodeUrl.verifyVerificationCode,
    },
    onSuccess: req.onSuccess,
    onError: req.onError,
  });
}
